import { useContext, useEffect, useState } from "react";
import GuiContext from "config/context/guiContext";
import styles from "css/userGui.module.css";
// import MemoryTransactions from "./MemoryTransactions";
import useTheme from "config/useTheme";
import ExplorerWidget from "./explorer-widget/ExplorerWidget";
import PluginsContext from "config/context/pluginsContext";
import DatabaseOverviewWidget from "./database-overview-widget/DatabaseOverviewWidget";
import ServerMonitoring from "./monitoring/ServerMonitoring";
import { MemoryOverviewWidget, MemoryContextProvider } from "features/memory";
import MemoryErrorBoundary from "features/memory/components/MemoryErrorBoundary";

const UserGUI = () => {
  const { dark } = useTheme();
  const { getActiveByAccountName } = useContext(PluginsContext);
  const {
    userData: { guiname },
  } = useContext(GuiContext);
  const [activePlugins, setActivePlugins] = useState([]);

  useEffect(() => {
    const activePluginsByAccount = getActiveByAccountName(guiname)?.active;
    if (activePluginsByAccount) {
      setActivePlugins(activePluginsByAccount);
    }
  }, [guiname, getActiveByAccountName, setActivePlugins]);

  return (
    <MemoryContextProvider>
      <section className={`${styles.userGui} ${dark ? styles.dark : ""}`}>
        <div className={styles.monitoring_area}>
          <ServerMonitoring />
        </div>
        <div className={styles.cardControl}>
          {activePlugins?.includes(9) && <ExplorerWidget />}
          <DatabaseOverviewWidget />
          <MemoryErrorBoundary>
            <MemoryOverviewWidget />
          </MemoryErrorBoundary>
        </div>
        {/* <div className={styles.bottomDashboardComponents}>
          <MemoryTransactions />
        </div> */}
      </section>
    </MemoryContextProvider>
  );
};

export default UserGUI;
